"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _Input = _interopRequireDefault(require("@material-ui/core/Input"));

var _reactSelect = _interopRequireWildcard(require("react-select"));

var _reactNumberFormat = _interopRequireDefault(require("react-number-format"));

var _Label = _interopRequireDefault(require("./Label"));

var _Errors = _interopRequireDefault(require("./Errors"));

var _FieldDescription = _interopRequireDefault(require("../../FieldDescription"));

var _FlexContainer = _interopRequireDefault(require("../../FlexContainer"));

var _iso = _interopRequireDefault(require("../../helpers/iso4217"));

var _validateInput = _interopRequireDefault(require("../validations/validateInput"));

var _CurrencyInput = require("./CurrencyInput.config");

var _ = require("../..");

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _templateObject, _templateObject2;

var _excluded = ["children"];

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var CurrencyInput = function CurrencyInput(_ref) {
  var id = _ref.id,
      _ref$value = _ref.value,
      value = _ref$value === void 0 ? '' : _ref$value,
      onChange = _ref.onChange,
      _ref$validations = _ref.validations,
      validations = _ref$validations === void 0 ? [] : _ref$validations,
      isFirstInput = _ref.isFirstInput,
      dependencies = _ref.dependencies,
      validationDependency = _ref.validationDependency,
      errorHandler = _ref.errorHandler,
      _ref$errors = _ref.errors,
      errors = _ref$errors === void 0 ? [] : _ref$errors,
      _ref$disabled = _ref.disabled,
      disabled = _ref$disabled === void 0 ? false : _ref$disabled,
      options = _ref.options,
      _ref$customLabel = _ref.customLabel,
      customLabel = _ref$customLabel === void 0 ? false : _ref$customLabel,
      _ref$handleKeyPress = _ref.handleKeyPress,
      handleKeyPress = _ref$handleKeyPress === void 0 ? function () {} : _ref$handleKeyPress,
      _ref$customValidation = _ref.customValidations,
      customValidations = _ref$customValidation === void 0 ? {} : _ref$customValidation,
      noFocus = _ref.noFocus,
      postErrors = _ref.postErrors,
      fieldDescription = _ref.fieldDescription,
      formattingOptions = _ref.formattingOptions,
      labelTooltip = _ref.labelTooltip,
      t = _ref.t;

  var _React$useState = _react.default.useState(true),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      formattingActive = _React$useState2[0],
      setFormattingActive = _React$useState2[1];

  var currencyOptions = options === null || options === void 0 ? void 0 : options.filter(function (o) {
    return (0, _.ifBoolParse)(o.value);
  }).map(function (o) {
    return {
      value: o.label,
      label: o.label
    };
  });

  var _getCurrencySeparator = (0, _CurrencyInput.getCurrencySeparators)(formattingOptions),
      thousandsSeparator = _getCurrencySeparator.thousandsSeparator,
      decimalSeparator = _getCurrencySeparator.decimalSeparator,
      decimalScale = _getCurrencySeparator.decimalScale;

  var _parseCurrencyValue = (0, _CurrencyInput.parseCurrencyValue)(value, decimalSeparator, decimalScale),
      currency = _parseCurrencyValue.currency,
      amount = _parseCurrencyValue.amount;

  var currencyOption = currencyOptions === null || currencyOptions === void 0 ? void 0 : currencyOptions.find(function (option) {
    return option.value === currency;
  });
  var validationsArray = (0, _CurrencyInput.getValidationsArray)(dependencies, options, value, validations, validationDependency);

  var handleCurrencyChange = function handleCurrencyChange(option) {
    return onChange(id, "".concat(amount).concat((option === null || option === void 0 ? void 0 : option.value) || '') || undefined);
  };

  var handleAmountChange = function handleAmountChange(inputValues) {
    var amount = (0, _CurrencyInput.trimDecimals)(inputValues.value, decimalSeparator, decimalScale);
    onChange(id, "".concat(amount).concat((currencyOption === null || currencyOption === void 0 ? void 0 : currencyOption.value) || ''));
  };

  var inputValidation = function inputValidation(valueToCheck) {
    _validateInput.default && (0, _validateInput.default)({
      value: valueToCheck,
      validations: [].concat(_toConsumableArray(validationsArray), [_.VALIDATIONS.REQUIRED_CURRENCY]),
      validationDependency: validationDependency,
      errorHandler: errorHandler,
      dependencies: dependencies,
      customValidations: customValidations,
      id: id
    });
  };

  _react.default.useEffect(function () {
    inputValidation(value);
  }, [value]);

  _react.default.useEffect(function () {
    handleCurrencyChange(currencyOption);
  }, [currencyOption === null || currencyOption === void 0 ? void 0 : currencyOption.value]);

  return _react.default.createElement(_react.default.Fragment, null, customLabel && _react.default.createElement(_Label.default, {
    customLabel: customLabel,
    tooltip: labelTooltip
  }), fieldDescription && _react.default.createElement(_FieldDescription.default, {
    value: fieldDescription
  }), _react.default.createElement(_FlexContainer.default, null, _react.default.createElement(_reactSelect.default, {
    isClearable: true,
    isDisabled: disabled,
    value: currencyOption,
    placeholder: "Currency",
    options: currencyOptions,
    styles: _CurrencyInput.currencySelectorStyles,
    onChange: handleCurrencyChange,
    formatOptionLabel: function formatOptionLabel(option) {
      var _CURRENCIES$option$va;

      return _react.default.createElement(_FlexContainer.default, {
        alignItems: "center",
        gap: "0.25rem"
      }, _react.default.createElement(StyledCurrencyText, null, option === null || option === void 0 ? void 0 : option.value), _react.default.createElement(StyledCurrencyText, null, "-"), _react.default.createElement(StyledCurrencyName, null, (_CURRENCIES$option$va = _iso.default[option === null || option === void 0 ? void 0 : option.value]) === null || _CURRENCIES$option$va === void 0 ? void 0 : _CURRENCIES$option$va.name));
    },
    components: {
      ValueContainer: function ValueContainer(_ref2) {
        var _props$getValue;

        var children = _ref2.children,
            props = _objectWithoutProperties(_ref2, _excluded);

        var hasValue = props.hasValue;
        var option = (_props$getValue = props.getValue()) === null || _props$getValue === void 0 ? void 0 : _props$getValue[0];

        if (!hasValue || !option) {
          return _react.default.createElement(_reactSelect.components.ValueContainer, props, children);
        }

        return _react.default.createElement(_reactSelect.components.ValueContainer, props, _react.default.createElement(_FlexContainer.default, {
          alignItems: "center",
          justifyContent: "center"
        }, option === null || option === void 0 ? void 0 : option.value));
      }
    }
  }), _react.default.createElement(_reactNumberFormat.default, {
    id: id,
    disabled: disabled,
    customInput: _Input.default,
    value: amount,
    allowNegative: false,
    fixedDecimalScale: true,
    decimalSeparator: decimalSeparator,
    decimalScale: formattingActive ? decimalScale : undefined,
    thousandSeparator: thousandsSeparator,
    autoFocus: isFirstInput && !noFocus,
    style: {
      marginBottom: 0
    },
    onValueChange: handleAmountChange,
    onKeyDown: function onKeyDown(e) {
      return handleKeyPress && handleKeyPress(e);
    },
    onBlur: function onBlur() {
      return setFormattingActive(true);
    },
    onFocus: function onFocus() {
      return setFormattingActive(false);
    }
  })), _react.default.createElement(_Errors.default, {
    errors: postErrors ? [].concat(_toConsumableArray(errors), [postErrors.message]) : errors,
    t: t
  }));
};

var StyledCurrencyText = _styledComponents.default.span(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    font-weight: 600;\n    font-family: monospace;\n"])));

var StyledCurrencyName = _styledComponents.default.span(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n    opacity: 0.7;\n    white-space: nowrap;\n"])));

var _default = CurrencyInput;
exports.default = _default;